// Support for future loading functionality
export const general = {
    state: {
        loading: false,
    },
    mutations: {
        startLoading: (state) => {
            state.loading = true;
        },
        stopLoading: (state) => {
            state.loading = false;
        },
    },
    actions: {},
    getters: {
        loading: (state) => {
            return state.loading;
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/General.js